import { AUTHENTICATING_PIPEDRIVE_REQUEST, AUTHENTICATING_PIPEDRIVE_SUCCEDDED, AUTHENTICATING_PIPEDRIVE_FAILED,
  FETCHING_PIPEDRIVE_MASTER_CONFIG_REQUEST, FETCHING_PIPEDRIVE_MASTER_CONFIG_SUCCEDDED, FETCHING_PIPEDRIVE_MASTER_CONFIG_FAILED,
  UPDATING_PIPEDRIVE_REQUEST, UPDATING_PIPEDRIVE_SUCCEDDED, UPDATING_PIPEDRIVE_FAILED,
  SYNCHRONISING_PIPEDRIVE_REQUEST, SYNCHRONISING_PIPEDRIVE_SUCCEDDED, SYNCHRONISING_PIPEDRIVE_FAILED,
  FETCHING_PIPEDRIVE_SYNC_DETAILS_REQUEST, FETCHING_PIPEDRIVE_SYNC_DETAILS_SUCCEDDED, FETCHING_PIPEDRIVE_SYNC_DETAILS_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  config: {
    loading: false,
    item: null,
    error: null
  },
  synchronisation: {
    synchronising: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function pipedriveReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_PIPEDRIVE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })

    case AUTHENTICATING_PIPEDRIVE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })

    case AUTHENTICATING_PIPEDRIVE_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      })

    case FETCHING_PIPEDRIVE_MASTER_CONFIG_REQUEST:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: true,
          error: null
        }
      })
    case FETCHING_PIPEDRIVE_MASTER_CONFIG_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: action.payload,
          error: null
        }
      })
    case FETCHING_PIPEDRIVE_MASTER_CONFIG_FAILED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: null,
          error: action.payload
        }
      }) 

    case UPDATING_PIPEDRIVE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_PIPEDRIVE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_PIPEDRIVE_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })

    case SYNCHRONISING_PIPEDRIVE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: true,
          error: null
        }

      })
    case SYNCHRONISING_PIPEDRIVE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: null
        }
      })
    case SYNCHRONISING_PIPEDRIVE_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: action.payload
        }
      })
    
    case FETCHING_PIPEDRIVE_SYNC_DETAILS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: null
        }

      })
    case FETCHING_PIPEDRIVE_SYNC_DETAILS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: action.payload.syncInProgress,
          error: null
        }
      })
    case FETCHING_PIPEDRIVE_SYNC_DETAILS_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: action.payload
        }
      })   
    
    default:
      return state;
  }
}

export { pipedriveReducer };